import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
export class Dashboard {
    initLightbox() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: "#gallery",
            children: "a",
            pswpModule: () => import("photoswipe"),
        });
        lightbox.init();
    }
}
